module.exports = __webpack_public_path__ + "media/images/sample-sitter-2-bc2daa5e3a12d0065ba340d991ffa1da.jpg";